<div class="row row-gap-2">
  <h2 class="h6">{{ 'meterPoint.meterPointChangeRequest.invoicingAddress' | translate }}</h2>
  <span class="address-text">{{ invoicingAddress() }}</span>
</div>
